var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-inventario"},[_c('v-form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"input-label primary--text"},[_vm._v("Valor")]),_c('v-text-field',{attrs:{"type":"tel","color":"grey1"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }